import { Component, OnInit } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { ActivatedRoute, ParamMap, } from '@angular/router';
import { finalize } from 'rxjs';
import { AuthService } from '../shared/services/auth.service';

@Component({
  selector: 'app-password-reset',
  templateUrl: './password-reset.component.html',
  styleUrls: ['./password-reset.component.less']
})
export class PasswordResetComponent implements OnInit {
	processingRequest: boolean = false;
	passwordReset: boolean = false;
	resetCode?: string | null | undefined;
	email?: string | null | undefined;

	readonly passwordResetForm = new FormGroup({
		password: new FormControl<string>('', [Validators.required])
	});

	constructor(
		private readonly _authService: AuthService,
		private readonly _route: ActivatedRoute
	) { }

	ngOnInit(): void {
		this._route.queryParamMap.subscribe((params: ParamMap) => {
			this.resetCode = params.get("code");
			this.email = params.get("email");
		});
	}

	public resetPassword() {
		if (!this.passwordResetForm.valid) {
			return;
		}
		this.processingRequest = true;
		this._authService.resetPassword(this.email!, this.resetCode!, this.passwordResetForm.get("password")!.value!)
			.pipe(
				finalize(() => {
					this.processingRequest = false;
				})
			)
			.subscribe({
				next: (v) => {
					this.passwordReset = true;
				}
			})
	}
}